import React from 'react';

import { Skeleton } from 'antd';

interface ViewerContentProps {
  src: string;
  title: string;
  reportKey: string;
  iframeLoaded: boolean;
  onIframeLoad: () => void;
  isFullscreen: boolean;
  vh: number;
  heightOffset: number;
  heightPadding: number;
  containerRef: React.RefObject<HTMLDivElement>;
}

const ViewerContent: React.FC<ViewerContentProps> = ({
  src,
  title,
  reportKey,
  iframeLoaded,
  onIframeLoad,
  isFullscreen,
  vh,
  heightOffset,
  heightPadding,
  containerRef,
}) => {
  return (
    <div
      ref={containerRef}
      style={{ width: '100%', height: '100%', position: 'relative' }}
    >
      {(!src || !iframeLoaded) && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: '#fff',
            zIndex: 5,
          }}
        >
          <Skeleton paragraph={{ rows: 4 }} />
        </div>
      )}
      {src && (
        <iframe
          key={reportKey}
          src={src}
          title={title}
          frameBorder={0}
          onLoad={onIframeLoad}
          style={{
            marginTop: '0',
            width: '100%',
            height: isFullscreen
              ? '100%'
              : `${vh - heightOffset - heightPadding}px`,
            border: 'none',
            visibility: iframeLoaded ? 'visible' : 'hidden',
          }}
        />
      )}
    </div>
  );
};

export default ViewerContent;
